import axios from 'axios';

const base_url = 'https://api.homehive.co.zw/api';

const getAuthConfig = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const messageService = {
  // Get all conversations
  getConversations: async () => {
    try {
      const response = await axios.get(
        `${base_url}/conversations/`,
        getAuthConfig()
      );
      return response.data;
    } catch (error) {
      console.error('Error in getConversations:', error);
      throw error.response?.data?.message || 'Failed to load conversations';
    }
  },

  // Get a single conversation with messages
  getConversation: async (conversationId, page = 1, pageSize = 20) => {
    try {
      const response = await axios.get(
        `${base_url}/conversations/${conversationId}/`,
        {
          ...getAuthConfig(),
          params: {
            page,
            page_size: pageSize
          }
        }
      );

      console.log('Raw API Response:', response.data);

      // Don't validate participants here, just return the raw data
      return {
        conversation: response.data,
        messages: response.data.messages || [],
        has_more: false // Since your API doesn't return this
      };
    } catch (error) {
      console.error('Error in getConversation:', error);
      throw error.response?.data?.message || 'Failed to load conversation';
    }
  },

  // Start a new conversation
  startConversation: async (userId, propertyId = null) => {
    try {
      const response = await axios.post(
        `${base_url}/conversations/`,
        {
          user_id: userId,
          property_id: propertyId
        },
        getAuthConfig()
      );
      return response.data;
    } catch (error) {
      console.error('Error in startConversation:', error);
      throw error.response?.data?.message || 'Failed to start conversation';
    }
  },

  // Send a message
  sendMessage: async (conversationId, content) => {
    try {
      const response = await axios.post(
        `${base_url}/conversations/${conversationId}/messages/`,
        { content },
        getAuthConfig()
      );
      return response.data;
    } catch (error) {
      console.error('Error in sendMessage:', error);
      throw error.response?.data?.message || 'Failed to send message';
    }
  }
};

export default messageService; 